import axios from 'axios'
import React, { useEffect, useState } from 'react'

function PrivicyPolicy() {
    const [data, setData] = useState('')
    const privicyData = async () => {
        try {
            const response = await axios.get('https://api.ipinplus.com/privacy')
            const { success, message, data } = response.data
            if (success) {
                setData(data.description)
            }
        } catch (err) {
            console.log(err)
        }
    }




    useEffect(() => {
        privicyData()
    }, [])
    return (
        <div>
            <h1>Privicy and Policy</h1>
            <div className="policy-container">
                {data && <div dangerouslySetInnerHTML={{ __html: data }} />}
            </div>
        </div>
    )
}

export default PrivicyPolicy 
